import { Injectable } from "@angular/core";
import { AnalyticsTrackEvent } from "@kells/apis/analytics";
import { environment } from "apps/patient-reporting/src/environments/environment";
import { HALEON_GA_ID } from "../models/haleon-events";

/**
 * Sends analytics events to Haleon GA (G-Y4SDGB16F5) via gtag.
 * Use this service for Haleon-specific events so they are tracked in the Haleon property.
 * Events are only sent when running in production mode.
 */
@Injectable({
  providedIn: "root",
})
export class HaleonAnalyticsService {
  record<T>(event: AnalyticsTrackEvent<T>): void {
    if (!environment.production) return;

    const gtag = (window as any).gtag;

    if (typeof gtag !== "function") return;

    gtag("event", event.type, {
      ...(event.detail && typeof event.detail === "object" ? event.detail : {}),
      send_to: HALEON_GA_ID,
    });
  }
}
